import { installSessionExpiry } from "./sessionExpiry";
import { onLandingSessionExpiry } from "./sessionExpiryConfig";

// Effet de bord voulu : importé en premier par index.js (voir sessionExpiry.js).
installSessionExpiry(onLandingSessionExpiry);
